export default __webpack_public_path__ + "navigation-examples-embedded-navigation-v1-1200-fff15dc1f1280ae3bfe1db31ce0a4b53.png";